import React, { memo } from 'react';
import { useDroppable } from '@dnd-kit/core';
import {
	SortableContext,
	horizontalListSortingStrategy,
	verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { areEqualWithCtx } from './helpers';
import classNames from 'classnames'

function getStrategy(direction) {
	switch (direction) {
		case 'Horizontal':
			return horizontalListSortingStrategy;
		case 'Vertical':
			return verticalListSortingStrategy;
	}
}

function useListClasses({
	direction,
	isDroppable,
	className,
	isDropzoneHovered,
}) {
	return classNames([
		className,
		{
			'is-droppable': isDroppable,
			'is-active-dropzone': isDropzoneHovered,
			'sortable-list-horizontal': direction === 'Horizontal',
			'sortable-list-vertical': direction === 'Vertical',
		},
	]);
}

export const SortableList = memo(function SortableList({
	direction,
	children,
	content,
	className,
}) {
	return (
		<SortableContext
			id={`sortable-${content.id}`}
			items={content.children}
			strategy={getStrategy(direction)}
		>
			<div
				className={useListClasses({
					direction,
					isDroppable: false,
					className,
				})}
			>
				{children}
			</div>
		</SortableContext>
	);
},
areEqualWithCtx);

export const SortableDroppableList = memo(function SortableDroppableList({
	accepts,
	direction,
	content,
	children,
	className,
	ctx,
}) {
	const sortableId = `sortable-${content.id}`;
	const { active, over, isOver, setNodeRef } = useDroppable({
		id: `droppable-${content.id}`,
		data: ctx,
	});

	const isDropzoneHovered =
		active?.data.current?.data.type === accepts &&
		(isOver || over?.data.current?.sortable?.containerId === sortableId);

	return (
		<SortableContext
			id={sortableId}
			items={content.children}
			strategy={getStrategy(direction)}
		>
			<div
				ref={setNodeRef}
				className={useListClasses({
					direction,
					isDroppable: true,
					className,
					isDropzoneHovered,
				})}
			>
				{children}
			</div>
		</SortableContext>
	);
},
areEqualWithCtx);

export const SortableListOverlay = memo(function SortableListOverlay({
	direction,
	children,
	className,
}) {
	return (
		<div
			className={useListClasses({ direction, isDroppable: false, className })}
		>
			{children}
		</div>
	);
},
areEqualWithCtx);
